export const FETCH_ALL='FETCH_ALL';
export const CREATE='CREATE';
export const UPDATE='UPDATE';
export const DELETE='DELETE';
export const UPDATE_LIKE='UPDATE_LIKE';